/**
 * Blog API Logic
 * Functions to load blog posts from the blogs subdirectory structure
 */

import { getAllBlogs, getBlogBySlug, getBlogContent } from '../blogs';

/**
 * Load all blog posts
 * @param {string} language - Language code (en, de, etc.)
 * @returns {Promise<{success: boolean, data: Array}>}
 */
export async function loadAllBlogs(language = 'en') {
  try {
    const allBlogs = getAllBlogs();
    
    // Enrich each blog with content for the specified language
    const blogsWithContent = allBlogs.map(blog => {
      const content = getBlogContent(blog.slug, language);
      return {
        ...blog,
        ...content
      };
    });

    return {
      success: true,
      data: blogsWithContent
    };
  } catch (error) {
    console.error('Error loading blogs:', error);
    return {
      success: false,
      data: [],
      error: error.message
    };
  }
}

/**
 * Load a specific blog post by slug
 * @param {string} slug - Blog post slug
 * @param {string} language - Language code (en, de, etc.)
 * @returns {Promise<{success: boolean, data: object | null}>}
 */
export async function loadBlogPost(slug, language = 'en') {
  try {
    const blog = getBlogBySlug(slug, language);
    
    if (!blog) {
      return {
        success: false,
        data: null,
        error: 'Blog post not found'
      };
    }

    return {
      success: true,
      data: blog
    };
  } catch (error) {
    console.error('Error loading blog post:', error);
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
}

/**
 * Load blog data (legacy function for backward compatibility)
 * @returns {Promise<{success: boolean, data: object | null}>}
 */
export async function loadBlogData() {
  return loadAllBlogs('en');
}


